import { render, staticRenderFns } from "./FormDetail.vue?vue&type=template&id=2d0a91ff&"
import script from "./FormDetail.vue?vue&type=script&lang=ts&"
export * from "./FormDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d0a91ff')) {
      api.createRecord('2d0a91ff', component.options)
    } else {
      api.reload('2d0a91ff', component.options)
    }
    module.hot.accept("./FormDetail.vue?vue&type=template&id=2d0a91ff&", function () {
      api.rerender('2d0a91ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TruckingSalesOrder/FormDetail.vue"
export default component.exports